module.exports = __webpack_public_path__ + "static/media/IMG_3083-min.18b2b941.jpg";